// UI strings (F-14). Keys must exist in both languages (checked by scripts/check-i18n.mjs, E-14).

export const HELP_KEYS: [string[], string][] = [
  [
    [
      "Space"
    ],
    "help.k.play"
  ],
  [
    [
      "←",
      "→"
    ],
    "help.k.step"
  ],
  [
    [
      "Shift+←",
      "Shift+→"
    ],
    "help.k.step10"
  ],
  [
    [
      "Home",
      "End"
    ],
    "help.k.startEnd"
  ],
  [
    [
      "J",
      "K",
      "L"
    ],
    "help.k.jkl"
  ],
  [
    [
      "I",
      "O"
    ],
    "help.k.inOut"
  ],
  [
    [
      "[",
      "]"
    ],
    "help.k.offset"
  ],
  [
    [
      "1",
      "2",
      "3",
      "4"
    ],
    "help.k.sources"
  ],
  [
    [
      "Q"
    ],
    "help.k.layout"
  ],
  [
    [
      "W"
    ],
    "help.k.mode"
  ],
  [
    [
      "D"
    ],
    "help.k.diff"
  ],
  [
    [
      "F"
    ],
    "help.k.fit"
  ],
  [
    [
      "0"
    ],
    "help.k.actual"
  ],
  [
    [
      "Shift+F"
    ],
    "help.k.fullscreen"
  ],
  [
    [
      "C"
    ],
    "help.k.crosshair"
  ],
  [
    [
      "+",
      "-"
    ],
    "help.k.level"
  ],
  [
    [
      "key.altArrows"
    ],
    "help.k.moveCross"
  ],
  [
    [
      "T",
      "B",
      "E",
      "A"
    ],
    "help.k.tools"
  ],
  [
    [
      "M"
    ],
    "help.k.quickNote"
  ],
  [
    [
      ",",
      "."
    ],
    "help.k.annoNav"
  ],
  [
    [
      "Delete"
    ],
    "help.k.annoDelete"
  ],
  [
    [
      "S"
    ],
    "help.k.scopes"
  ],
  [
    [
      "P"
    ],
    "help.k.sampler"
  ],
  [
    [
      "V"
    ],
    "help.k.adjust"
  ],
  [
    [
      "Shift+V"
    ],
    "help.k.preset"
  ],
  [
    [
      "G"
    ],
    "help.k.texture"
  ],
  [
    [
      "R"
    ],
    "help.k.mask"
  ],
  [
    [
      "Ctrl+S"
    ],
    "help.k.save"
  ],
  [
    [
      "?"
    ],
    "help.k.help"
  ],
  [
    [
      "Esc"
    ],
    "help.k.esc"
  ]
];

export const ZH_TW: Record<string, string> = {
  "app.demoNotice": "介面示範 · 合成畫面，不含解碼",
  "project.untitled": "未命名專案",
  "toolbar.open": "開啟…",
  "toolbar.save": "儲存",
  "toolbar.saveTip": "儲存目前的專案（Ctrl+S；按住 Shift 為另存新檔）",
  "toolbar.export": "輸出",
  "toolbar.addVersion": "＋ 新增版本",
  "toolbar.dock": "面板",
  "toolbar.settings": "設定",
  "toolbar.help": "說明",
  "toolbar.crosshair": "準星",
  "toolbar.rightSource": "右側版本",
  "toolbar.align": "對齊…",
  "layout.label": "版面",
  "layout.sbs": "並排",
  "layout.sbs-zoom": "並排＋放大",
  "layout.quad": "四格",
  "layout.single": "單畫面",
  "mode.label": "比較",
  "mode.sbs": "並排",
  "mode.wipe": "Wipe",
  "mode.overlay": "疊加",
  "mode.flicker": "閃切",
  "mode.diff": "差異",
  "params.angle": "角度",
  "params.opacity": "AI 輸出透明度",
  "params.flickerInfo": "每秒切換 {hz} 次（在設定中調整）",
  "params.gain": "增益",
  "params.gray": "灰階",
  "params.heat": "熱度圖",
  "params.luma": "只看亮度",
  "view.fit": "符合視窗",
  "view.actual": "100%",
  "zoom.label": "放大倍率",
  "zoom.down": "縮小一級（-）",
  "zoom.up": "放大一級（+）",
  "dur.frame": "1 格",
  "dur.sec": "{s} 秒",
  "synth.A": "原片",
  "synth.B1": "版本一（換場景）",
  "synth.B2": "版本二（重打光）",
  "synth.B3": "版本三（捏造細節）",
  "badge.display": "顯示 {p}%",
  "badge.zoom": "放大 {p}%",
  "badge.outOfRange": "{id} 超出範圍",
  "badge.grid": "{id} 比較基準放大 {p}%",
  "badge.offset": "{id} 偏移 {n} 格",
  "badge.proxy": "播放中使用代理畫面（不可判斷閃爍與紋理）",
  "badge.dropping": "掉格中",
  "badge.flickerNow": "目前顯示：{id}",
  "badge.adjust": "檢視調整中",
  "badge.adjustB": "只套用到 {id}",
  "badge.channel": "通道檢視：{c}",
  "badge.texture": "灰階紋理檢視",
  "align.mode.center": "置中不縮放",
  "align.mode.stretch": "拉伸到 A",
  "align.mode.fit": "等比符合",
  "align.mode.topleft": "左上對齊",
  "align.mode.manual": "手動",
  "align.mode.identity": "基準",
  "align.title": "對齊",
  "align.info": "{id} {bw}×{bh} → A {aw}×{ah}（{p}%）",
  "align.needB": "請先載入 A 與一個 AI 輸出",
  "align.sameSize": "與 A 同尺寸，通常不需要對齊",
  "align.estimating": "估算中…",
  "align.apply": "套用",
  "align.applied": "已套用：",
  "align.reset": "重設為置中",
  "align.dx": "X 位移（A 像素）",
  "align.dy": "Y 位移（A 像素）",
  "align.sx": "寬縮放（%）",
  "align.sy": "高縮放（%）",
  "align.scale": "縮放 X {sx}% Y {sy}%",
  "align.crop": "裁切 {v}",
  "align.gap": "留黑 {v}",
  "align.showDiff": "顯示差異",
  "align.note": "比較基準固定為 A 的像素格（D-37）。AI 輸出超出 A 的部分被裁掉，不足的部分顯示黑色。",
  "edge.l": "左",
  "edge.r": "右",
  "edge.t": "上",
  "edge.b": "下",
  "composite.wipe": "Wipe：{a} ｜ {b}",
  "composite.overlay": "疊加：{a} ＋ {b} {p}%",
  "composite.flicker": "閃切：{a} ⇄ {b}（{hz} Hz）",
  "composite.diff": "差異：|{a} − {b}| ×{g}",
  "drop.A": "拖放原始影片到這裡（A）",
  "drop.B": "拖放 AI 輸出到這裡（{id}）",
  "drop.hint": "可一次拖入多支影片（依檔名排序填入 A、B、C、D），PNG／EXR 序列可拖入整個資料夾，也可拖入 .acproj 專案檔；可直接從 moonland 頁面把影片拖到任一格，或按 Ctrl+V 貼上 moonland／Google 雲端硬碟／YouTube 的影片網址。",
  "drop.pick": "選擇影片…",
  "drop.synth": "使用合成示範畫面",
  "timeline.play": "播放（Space）",
  "timeline.pause": "暫停（Space）",
  "timeline.start": "到開頭（Home）",
  "timeline.end": "到結尾（End）",
  "timeline.stepBack": "後退一格（←）",
  "timeline.stepFwd": "前進一格（→）",
  "timeline.tcToggle": "點擊切換：內嵌時間碼／從零起算",
  "timeline.tcEmbedded": "內嵌時間碼",
  "timeline.tcZero": "從零起算",
  "timeline.noEmbedded": "無內嵌時間碼，從零起算",
  "timeline.offset": "{id} 偏移 {n} 格",
  "timeline.noB": "尚未載入 AI 輸出",
  "timeline.offDown": "選定的版本偏移 -1 格（[）",
  "timeline.offUp": "選定的版本偏移 +1 格（]）",
  "timeline.length": "{n} 格 · {fps} fps",
  "timeline.in": "入點",
  "timeline.inTip": "設定入點（I）",
  "timeline.out": "出點",
  "timeline.outTip": "設定出點（O）",
  "timeline.clearIO": "清除",
  "loop.loop": "循環",
  "loop.once": "單次",
  "loop.pingpong": "來回",
  "audio.label": "音訊",
  "audio.none": "（無音軌）",
  "audio.mute": "靜音",
  "dock.adjust": "調整",
  "dock.mask": "遮罩",
  "dock.info": "素材",
  "adjust.enable": "啟用檢視調整（V）",
  "adjust.linked": "連動所有來源",
  "adjust.presets": "預設",
  "preset.shadows": "暗部檢查",
  "preset.highlights": "亮部檢查",
  "preset.banding": "斷層放大",
  "adjust.exposure": "曝光（stop）",
  "adjust.gamma": "Gamma",
  "adjust.levels": "Levels",
  "adjust.inBlack": "輸入黑點",
  "adjust.inWhite": "輸入白點",
  "adjust.mid": "中間調",
  "adjust.outBlack": "輸出黑點",
  "adjust.outWhite": "輸出白點",
  "adjust.reset": "全部重設",
  "adjust.viewTitle": "檢視方式",
  "adjust.channel": "通道",
  "channel.rgb": "RGB",
  "channel.r": "R",
  "channel.g": "G",
  "channel.b": "B",
  "channel.luma": "Luma",
  "adjust.texture": "灰階紋理檢視（G）：加強局部對比，看毛孔、皺紋是否消失或游動",
  "adjust.note": "只改變畫面顯示，不改變影片；輸出時預設不套用。",
  "info.specTitle": "詳細規格比對",
  "info.none": "尚未載入任何來源",
  "info.file": "檔名",
  "info.synth": "合成示範",
  "info.image": "圖片",
  "info.size": "解析度",
  "info.codec": "編碼",
  "info.fps": "幀率",
  "info.frames": "幀數",
  "info.bitDepth": "位元深度",
  "info.chroma": "色度取樣",
  "info.color": "色彩空間",
  "info.range": "Range",
  "info.tc": "時間碼",
  "info.noTc": "無",
  "info.audio": "音訊",
  "info.noAudio": "無",
  "info.vfr": "變動幀率",
  "info.yes": "是",
  "info.no": "否",
  "warn.size": "{id} 解析度 {b}，與 A 的 {a} 不同：請確認對齊方式（對齊…）",
  "warn.fps": "{id} 幀率 {b}，A 為 {a}：幀率被改變；幀數相同時仍逐格對應",
  "warn.frames": "{id} 有 {b} 格，A 有 {a} 格：超出的部分顯示黑畫面",
  "warn.bitDepth": "{id} 為 {b}-bit，A 為 {a}-bit：可能出現色階斷層",
  "warn.color": "{id} 色彩標記為 {b}，A 為 {a}：看起來偏色不一定是 AI 造成",
  "warn.tc": "{id} 沒有時間碼（A 有）",
  "warn.audio": "{id} 沒有音軌（A 有）",
  "export.title": "輸出",
  "export.template": "範本",
  "export.tpl.sbs": "並排",
  "export.tpl.sbs-zoom": "並排＋放大",
  "export.tpl.quad": "四格",
  "export.tpl.wipe": "動態 Wipe",
  "export.tpl.current": "目前畫面",
  "export.tpl.mask": "遮罩（黑白）",
  "export.labels": "標籤",
  "export.range": "範圍",
  "export.rangeAll": "全片",
  "export.rangeIO": "入點至出點",
  "export.codec": "編碼",
  "export.half": "縮為一半（方便分享）",
  "export.sumSize": "畫面尺寸 {w}×{h}",
  "export.sumScaled": "超過 3840×2160，已縮小為 {p}%",
  "export.sumFrames": "{n} 格（{s} 秒）",
  "export.go": "輸出",
  "export.goMaskFrame": "儲存這一格的遮罩 PNG",
  "settings.title": "設定",
  "settings.secView": "檢視",
  "settings.secDemo": "示範用",
  "settings.flickerHz": "閃切頻率",
  "settings.timecode": "時間碼顯示",
  "settings.frameBase": "幀號起算",
  "settings.degrade": "解碼跟不上時",
  "settings.degradeSmooth": "流暢優先（代理畫面）",
  "settings.degradeQuality": "畫質優先（允許掉格）",
  "settings.centerMark": "放大畫面顯示中心像素框",
  "settings.b1Size": "B 的輸出尺寸",
  "size.native": "1920×1080（與 A 相同）",
  "size.pad": "1988×1088 補邊",
  "size.stretch": "1988×1088 拉伸",
  "settings.simulateDegrade": "播放時模擬降級提示",
  "settings.dpr": "devicePixelRatio {v} · 畫布 {w}×{h} 實體像素",
  "settings.loadDemo": "重新載入合成示範",
  "settings.clearAll": "清空所有來源",
  "toast.modeOneToOne": "比較模式只用於一對一版面（並排、並排＋放大）",
  "toast.modeQuad": "四格版面可使用疊加與閃切；Wipe 與差異請切換到並排或並排＋放大",
  "toast.noSource": "{id} 尚未載入",
  "toast.added": "已加入 {id}（合成示範）",
  "toast.notImage": "示範版只接受圖片或 .acproj；正式版支援 MP4",
  "toast.loadFailed": "無法讀取 {name}",
  "toast.loaded": "已載入 {n} 張圖片",
  "toast.stillSaved": "已儲存 PNG",
  "toast.exportDemo": "示範版不會實際輸出影片",
  "toast.saved": "已儲存專案檔",
  "toast.opened": "已開啟 {name}",
  "toast.openFailed": "無法讀取專案檔",
  "toast.audioDemo": "示範版沒有聲音；正式版只在 1x 正向播放時播放音訊",
  "toast.noDownload": "分享版無法下載檔案；在本機執行 demo 時可以存檔",
  "help.title": "說明",
  "help.keysTitle": "快捷鍵",
  "help.mouseTitle": "滑鼠操作",
  "help.demoTitle": "這個示範",
  "help.tryTitle": "請試試看",
  "key.altArrows": "Alt+方向鍵",
  "help.k.play": "播放／暫停",
  "help.k.step": "逐格後退／前進",
  "help.k.step10": "後退／前進 10 格",
  "help.k.startEnd": "到開頭／結尾",
  "help.k.jkl": "倒放加速／暫停／正放加速",
  "help.k.inOut": "設定入點／出點",
  "help.k.offset": "選定的版本偏移 -1／+1 格",
  "help.k.sources": "短按：切換右側的比較版本（單畫面時切換來源）；按住：暫時全畫面，放開返回",
  "help.k.layout": "切換版面",
  "help.k.mode": "切換比較模式",
  "help.k.diff": "差異模式開關",
  "help.k.fit": "上方畫面符合視窗",
  "help.k.actual": "上方畫面 100% 實體像素",
  "help.k.fullscreen": "全螢幕並隱藏介面",
  "help.k.crosshair": "隱藏／顯示準星",
  "help.k.level": "放大倍率升降一級（100%～3000%）",
  "help.k.moveCross": "準星移動 1 像素；加 Shift 移動 10 像素",
  "help.k.adjust": "檢視調整開關",
  "help.k.preset": "切換檢視調整預設",
  "help.k.texture": "灰階紋理檢視",
  "help.k.save": "儲存專案檔",
  "help.k.help": "開關本說明",
  "help.k.esc": "關閉視窗／離開全螢幕／回到準星工具",
  "help.mouse1": "點擊上方畫面：把準星移到該位置，兩邊同時顯示",
  "help.mouse2": "在上方畫面拖曳：連續移動準星",
  "help.mouse3": "在下方放大畫面拖曳：平移放大位置；滾輪換倍率",
  "help.mouse4": "100% 模式下，右鍵或中鍵拖曳：平移上方畫面",
  "help.mouse5": "Wipe 模式：拖曳分隔線上的圓鈕移動分隔線",
  "help.mouse6": "上下區之間的橫條可拖曳調整高度",
  "help.mouse7": "把影片拖到任一格：載入或替換該來源；拖入 .acproj：開啟專案",
  "help.mouse8": "四格版面中雙擊某個 AI 輸出：回到與 A 一對一比較（F-04.5）",
  "help.demo1": "畫面是程式產生的合成影像，共 120 格，模擬 24 fps 播放；左上角燒入的是該來源自己的幀號",
  "help.demo2": "B 模擬換場景：背景替換、皮膚變塑膠感、膚色偏暖、頭髮邊緣光暈、耳環消失；預設輸出尺寸為 1988×1088（可在設定中改）",
  "help.demo3": "C 模擬重打光：整體偏暖、視線偏移，且比 A 短 10 格",
  "help.demo4": "D 模擬捏造細節：多出雀斑、毛孔加重、招牌文字變亂碼；色彩標記為 BT.601",
  "help.demo5": "示波器與取樣以 8-bit 計算；人物遮罩直接取自合成人物，正式版會用分割模型",
  "help.demo6": "不含：影片解碼、聲音、實際輸出影片（靜態 PNG 與遮罩單格可實際存檔）",
  "help.try1": "按「對齊…」看 B 的 1988×1088 怎麼對齊到 A，比較「置中不縮放」與「拉伸到 A」的差異圖",
  "help.try2": "點臉部、眼睛、頭髮邊緣，在下方用 400%～1000% 比對兩邊",
  "help.try3": "右側「示波器」：切換波形、Parade、向量、直方圖、碼值；範圍改為「放大區」只看準星附近",
  "help.try4": "右側「調整」：套用「暗部檢查」、改 Levels、切換通道與灰階紋理",
  "help.try5": "在「註記」分頁選方框，畫框加文字，設定起訖格，看時間軸上的範圍",
  "help.try6": "「遮罩」分頁計算人物遮罩，再試聚焦與「差異圖只看人物內」",
  "help.try7": "「輸出…」看四種輸出的選項與版面",
  "project.readOnly": "唯讀（較新版本的專案檔）",
  "project.warn.newer": "這個專案檔由較新版本的 AiComp 儲存，以唯讀方式開啟；另存新檔不會影響原檔。",
  "toolbar.openTip": "開啟 .acproj 專案檔，例如同事放在 NAS 上的專案（也可以直接拖到畫面上）",
  "toolbar.undo": "復原（Ctrl+Z）",
  "toolbar.redo": "重做（Ctrl+Shift+Z）",
  "toolbar.zoomDiff": "放大區差異",
  "toolbar.zoomDiffTip": "下方放大區右側改為顯示差異（F-06.6）",
  "toolbar.zoomGrid": "網格",
  "toolbar.zoomGridTip": "放大區顯示半透明網格，每格 10 像素（A 的像素），左右位置相同；2000% 以上在交點標出座標，方便對準比對像素差異",
  "layout.sbs.tip": "A｜比較版本 左右並排",
  "layout.sbs-zoom.tip": "上方並排、下方準星位置放大對照（核心工作方式）",
  "layout.quad.tip": "2×2：A、B、C、D",
  "layout.single.tip": "只顯示一格，用數字鍵切換來源",
  "mode.sbs.tip": "並排比較",
  "mode.wipe.tip": "可拖曳的分隔線，角度可調",
  "mode.overlay.tip": "比較版本半透明疊在 A 上",
  "mode.flicker.tip": "A 與比較版本自動交替（頻率在設定中）",
  "mode.diff.tip": "A 與比較版本的絕對差值（D）",
  "view.fitTip": "上方畫面符合視窗（F）",
  "view.actualTip": "上方畫面 100% 實體像素（0）；右鍵拖曳平移",
  "timeline.gotoTip": "點擊跳到指定幀號或時間碼（Ctrl+G）",
  "timeline.originalOnly": "只走原始格",
  "timeline.speed": "播放速度（0.25×～2×）",
  "audio.onlyAt1x": "只在 1× 正向播放時有聲音",
  "goto.title": "跳到指定位置",
  "goto.label": "幀號或時間碼",
  "goto.hint": "例如 120 或 01:00:05:12（依目前的時間碼顯示方式）",
  "goto.go": "跳到",
  "goto.invalid": "無法辨識或超出範圍",
  "align.freeResult": "X {sx}% Y {sy}% · 位移 {dx}, {dy}",
  "align.errorValue": "平均差異 {e}（越小越好）",
  "align.shift": "位移 {dx}, {dy}",
  "align.mode.center.tip": "四周補邊或裁邊（不重新取樣）",
  "align.mode.stretch.tip": "整個畫面被縮放成新尺寸",
  "align.mode.fit.tip": "等比縮放後留黑邊",
  "align.mode.topleft.tip": "只在右側與下方補邊",
  "badge.alignDiff": "對齊中：暫時顯示差異圖",
  "badge.approximate": "{id} 依時間對應（非逐格精準）",
  "badge.decoding": "解碼中…",
  "badge.frameError": "{id} 第 {n} 格解碼失敗",
  "badge.noCounterpart": "A 無對應格（生成幀）",
  "badge.zoomDiff": "{id} 顯示差異",
  "badge.proxyPaused": "代理畫面（完整解析度載入中）",
  "cap.title": "這個瀏覽器無法執行 AiComp",
  "cap.body": "請使用最新版 Chrome 或 Edge，並以 HTTPS 或 localhost 開啟。缺少的功能：",
  "cap.secure": "安全環境（HTTPS 或 localhost）",
  "cap.webcodecs": "WebCodecs（影片解碼）",
  "cap.webgl2": "WebGL2（畫面渲染）",
  "cap.workers": "Web Worker 與 OffscreenCanvas",
  "cap.indexeddb": "IndexedDB（自動暫存）",
  "drop.loading": "讀取中…",
  "drop.relink": "請拖入 {id} 的影片：{name}",
  "drop.relinkHint": "專案檔只記錄檔案資訊，不含影片本體；拖入後會以指紋確認是否為同一個檔案。",
  "drop.error": "無法使用 {name}",
  "drop.transcodeHint": "開著本機輔助程式（YouTube 輔助程式）時會自動轉檔；或用 HandBrake／Media Encoder 轉成 H.264 或 HEVC",
  "error.open.noVideo": "檔案中沒有影片軌",
  "error.open.undecodable": "這個瀏覽器無法解碼此編碼格式（{codec}），例如 ProRes、DNxHR、部分 4:2:2 或 10-bit H.264",
  "error.open.unreadable": "無法解析檔案（不支援的容器或檔案已損毀）",
  "error.open.unsupportedCodec": "不支援的編碼格式（{codec}）",
  "error.project.invalid": "這不是有效的 AiComp 專案檔",
  "error.project.parse": "專案檔格式錯誤，無法讀取",
  "error.project.version": "無法轉換這個專案檔的版本",
  "error.save": "儲存失敗：{detail}",
  "export.cancel": "取消",
  "help.aboutTitle": "關於",
  "help.about1": "所有解碼、比較與輸出都在這台電腦的瀏覽器中執行，影片、畫面與遮罩不會上傳到任何地方。",
  "help.about2": "畫面上顯示的永遠是正確的幀號；播放跟不上時依設定改用代理畫面或掉格，並在角落標示。",
  "help.about3": "暫停時以自己的 shader 轉換色彩（讀取原始碼值）；播放時使用 GPU 直通路徑並做色彩矩陣校正。",
  "help.about4": "硬體解碼的 10-bit HEVC 只能取得瀏覽器轉換後的 8-bit 資料，介面會註明。",
  "help.about5": "自我檢測頁（設定 → 自我檢測）可用燒入幀號的測試片確認這台電腦的逐格精準度。",
  "help.k.stepBack": "後退一格（補幀時為一個刻度）",
  "help.k.stepFwd": "前進一格",
  "help.k.back10": "後退 10 格",
  "help.k.fwd10": "前進 10 格",
  "help.k.start": "到開頭（或入點）",
  "help.k.end": "到結尾（或出點）",
  "help.k.j": "倒放（再按加速）",
  "help.k.k": "暫停",
  "help.k.l": "正放（再按加速）",
  "help.k.in": "設定入點",
  "help.k.out": "設定出點",
  "help.k.offDown": "選定的版本偏移 −1 格",
  "help.k.offUp": "選定的版本偏移 +1 格",
  "help.k.goto": "跳到指定幀號或時間碼",
  "help.k.zoomIn": "放大倍率升一級",
  "help.k.zoomOut": "放大倍率降一級",
  "help.k.crossLeft": "準星左移 1 像素",
  "help.k.crossRight": "準星右移 1 像素",
  "help.k.crossUp": "準星上移 1 像素",
  "help.k.crossDown": "準星下移 1 像素",
  "help.k.crossLeft10": "準星左移 10 像素",
  "help.k.crossRight10": "準星右移 10 像素",
  "help.k.crossUp10": "準星上移 10 像素",
  "help.k.crossDown10": "準星下移 10 像素",
  "help.k.undo": "復原",
  "help.k.redo": "重做",
  "info.sourcesTitle": "來源設定",
  "info.container": "容器",
  "info.duration": "長度",
  "info.bitrate": "影像碼率",
  "info.gop": "最長 GOP",
  "info.mapping": "幀對應",
  "info.decodePath": "解碼路徑",
  "info.decodeRaw": "原始碼值",
  "info.decodeBrowser": "瀏覽器轉換（8-bit）",
  "info.auto": "自動",
  "info.colorOverride": "色彩標記",
  "info.displayNamePh": "顯示名稱（例如：版本一 Topaz）",
  "info.replace": "替換…",
  "info.remove": "移除",
  "info.swapA": "與 A 對調",
  "mapping.one-to-one": "逐格",
  "mapping.ratio": "{n} 倍補幀",
  "mapping.time": "依時間（非逐格精準）",
  "mapping.reason.same": "幀數與幀率相同",
  "mapping.reason.sameRateDiffCount": "幀率相同、長度不同",
  "mapping.reason.ratio": "整數倍補幀",
  "mapping.reason.time": "幀率不是整數倍",
  "preset.customName": "自訂 {n}",
  "adjust.savePreset": "存成預設",
  "settings.alignDiff": "對齊時自動顯示差異圖",
  "settings.copyDiag": "複製診斷資訊",
  "settings.exportPreset": "匯出團隊預設檔…",
  "settings.importPreset": "匯入團隊預設檔…",
  "settings.perf": "效能資訊",
  "settings.sampling": "放大取樣方式",
  "settings.samplingNearest": "最近鄰（看真實像素）",
  "settings.samplingSmooth": "平滑插值",
  "settings.secSystem": "系統",
  "settings.secTeam": "團隊預設與快捷鍵",
  "settings.selftest": "自我檢測…",
  "settings.shortcuts": "自訂快捷鍵…",
  "settings.version": "AiComp {v} · 建置 {d}",
  "shortcuts.title": "自訂快捷鍵",
  "shortcuts.hint": "點擊右側按鈕後按下新的按鍵；Esc 取消。設定存在這台電腦，也可隨團隊預設檔匯出。",
  "shortcuts.action": "功能",
  "shortcuts.key": "按鍵",
  "shortcuts.press": "請按鍵…",
  "shortcuts.reserved": "這是瀏覽器保留的按鍵",
  "shortcuts.reset": "全部恢復預設",
  "spec.warn.aspect": "長寬比不同（A {a}，此版本 {b}）",
  "spec.warn.audioFormat": "音訊格式不同（A {a}，此版本 {b}）",
  "spec.warn.audioLength": "音訊長度不同（A {a} 秒，此版本 {b} 秒）",
  "spec.warn.audioMissing": "沒有音軌（A 有）",
  "spec.warn.audioOnlyB": "有音軌但 A 沒有",
  "spec.warn.bitDepth": "位元深度不同（A {a}-bit，此版本 {b}-bit），可能出現色階斷層",
  "spec.warn.chroma": "色度取樣為 {cs}",
  "spec.warn.chromaDiff": "色度取樣不同（A {a}，此版本 {b}）",
  "spec.warn.colorTags": "色彩原色或轉換特性標記與 A 不同",
  "spec.warn.fps": "幀率不同（A {a}，此版本 {b}）",
  "spec.warn.fpsMicro": "幀率被改變（A {a}，此版本 {b}）；幀數相同時仍逐格對應（D-20）",
  "spec.warn.frameCount": "幀數 {b}，預期 {a}（差 {diff}）；超出的部分顯示黑畫面，可能需要調整偏移",
  "spec.warn.hdr": "偵測到 HDR（PQ／HLG）：第一版不支援 HDR 精確顯示（C-08）",
  "spec.warn.interlaced": "偵測到交錯掃描",
  "spec.warn.matrix": "色彩矩陣標記不同（A {a}，此版本 {b}）：看起來偏色不一定是 AI 造成（C-04）",
  "spec.warn.noColorTags": "缺少色彩標記，使用預設值（HD 為 BT.709 limited，C-02）",
  "spec.warn.par": "非方形像素（PAR {par}）",
  "spec.warn.range": "Range 不同（A {a}，此版本 {b}）",
  "spec.warn.resolution": "解析度不同（A {a}，此版本 {b}）：請確認對齊方式（對齊…）",
  "spec.warn.rotation": "容器中有旋轉標記（{deg}°）",
  "spec.warn.timeMapping": "依時間對應：非逐格精準",
  "spec.warn.timecode": "起始時間碼不同（A {a}，此版本 {b}）",
  "spec.warn.undecodable": "瀏覽器無法解碼（{codec}）",
  "spec.warn.vfr": "變動幀率（VFR）會影響逐格對齊",
  "toast.diagCopied": "已複製診斷資訊（不含影片內容與檔案路徑）",
  "toast.diagFailed": "無法寫入剪貼簿",
  "toast.fingerprint": "{id}：{name} 與專案記錄的檔案不同，對齊與設定可能不對應",
  "toast.preset": "檢視調整：{name}",
  "toast.presetExported": "已匯出團隊預設檔",
  "toast.presetImported": "已匯入 {n} 個預設",
  "toast.presetInvalid": "不是有效的團隊預設檔",
  "toast.presetSaved": "已存成預設「{name}」",
  "toast.readOnly": "唯讀專案：請另存新檔",
  "export.errCodec": "這台電腦的瀏覽器無法以 {codec} 編碼 {w}×{h}；請改用 H.264 或勾選「縮為一半」",
  "export.burnScaled": "輸出畫面已縮小為 {p}%",
  "export.burnAdjusted": "已套用檢視調整",
  "export.slateTitle": "片頭卡標題",
  "export.slateSubtitle": "片頭卡副標",
  "export.bitrate": "碼率（Mbps）",
  "export.bitrateAuto": "自動（高碼率）",
  "export.needA": "需要先載入 A",
  "export.failed": "輸出失敗：{detail}",
  "export.cancelled": "已取消輸出",
  "export.done": "輸出完成（{s} 秒）",
  "export.maxRate": "以補幀後的最高幀率輸出（A 的格重複顯示）",
  "export.audio": "包含目前選定的音訊",
  "temporal.title": "時間對齊與掉格偵測",
  "temporal.hint": "比對 A 與這個版本的每一格，建議時間偏移（結果只作建議；掉格與重複格請用「檢查」分頁）",
  "temporal.onlyOneToOne": "只支援逐格對應的版本",
  "temporal.analyse": "分析",
  "temporal.again": "重新分析",
  "temporal.running": "分析中 {p}%…",
  "temporal.suggest": "建議 {id} 偏移 {n} 格",
  "temporal.confidence": "（信心 {c}）",
  "temporal.lowConfidence": "畫面變化太少，建議不可靠；請人工確認",
  "temporal.apply": "套用偏移",
  "temporal.none": "無法判斷偏移",
  "temporal.noEvents": "沒有偵測到少幀、多幀或重複幀",
  "temporal.ev.drop": "這裡少了 {n} 格（此版本第 {b} 格）",
  "temporal.ev.insert": "這裡多了 {n} 格（此版本第 {b} 格）",
  "temporal.ev.duplicate": "此版本第 {b} 格與前一格重複",
  "error.glLost": "顯示卡的繪圖環境暫時失效，正在自動復原…",
  "error.glRestored": "畫面已復原",
  "error.permission": "無法讀取 {id} 的 {name}（沒有取得權限或檔案已移動），請重新拖入",
  "params.vertical": "上下排列",
  "common.ok": "確定",
  "common.cancel": "取消",
  "toolbar.addVersionTip": "新增 AI 版本到這個鏡頭",
  "toolbar.crosshairTip": "準星（C 暫時隱藏）",
  "side.collapse": "收合專案清單",
  "side.expand": "展開專案清單",
  "tree.title": "專案",
  "tree.newProject": "＋ 新專案",
  "tree.newProjectTip": "建立新專案",
  "tree.newProjectTitle": "新專案",
  "tree.projectName": "專案名稱",
  "tree.search": "搜尋專案或鏡頭",
  "tree.legendLinked": "影片已連結",
  "tree.legendRelink": "需要指定影片",
  "tree.legendEmpty": "尚無影片",
  "tree.untitledShot": "鏡頭 {n}",
  "tree.shot": "鏡頭",
  "tree.copySuffix": " 副本",
  "tree.notSaved": "尚未存檔",
  "tree.dirtyTip": "有未儲存的變更",
  "tree.more": "更多（也可以按右鍵）",
  "tree.addShot": "＋ 新增鏡頭",
  "tree.noMatch": "找不到符合的專案或鏡頭",
  "tree.versions": "A＋{n} 版本",
  "tree.videos": "{n} 支影片",
  "tree.status.linked": "影片已連結",
  "tree.status.relink": "需要指定影片",
  "tree.status.empty": "尚無影片",
  "tree.status.loading": "讀取中",
  "tree.menu.save": "儲存",
  "tree.menu.saveAs": "另存新檔…",
  "tree.menu.mediaFolder": "選擇素材資料夾…",
  "tree.menu.rename": "重新命名",
  "tree.menu.addShot": "新增鏡頭",
  "tree.menu.dupProject": "複製專案",
  "tree.menu.dupShot": "複製鏡頭（含設定）",
  "tree.menu.moveShot": "移到其他專案…",
  "tree.menu.forget": "重新指定影片",
  "tree.menu.up": "上移",
  "tree.menu.down": "下移",
  "tree.menu.deleteShot": "刪除鏡頭",
  "tree.menu.close": "從清單關閉",
  "tree.moveTitle": "移到其他專案",
  "tree.deleteTitle": "刪除鏡頭",
  "tree.deleteBody": "確定刪除「{name}」？它的設定會從專案中移除（儲存後才寫入專案檔；影片檔不受影響）。",
  "tree.delete": "刪除",
  "tree.closeTitle": "從清單關閉",
  "tree.closeBody": "「{name}」有未儲存的變更。專案檔本身不會被刪除。",
  "tree.closeSave": "儲存後關閉",
  "tree.closeDiscard": "不儲存並關閉",
  "relink.title": "指定「{name}」的影片",
  "relink.desc": "專案檔只記錄影片的檔名、大小與指紋，不含影片本體。選一次素材資料夾，這個專案所有鏡頭的影片都會自動配對；也可以逐一選擇檔案，或把影片直接拖到畫面上。",
  "relink.allow": "允許讀取上次的影片",
  "relink.allowTip": "這台電腦記得上次的影片位置，瀏覽器需要你再允許一次讀取",
  "relink.folder": "選擇素材資料夾…",
  "relink.folderTip": "在本機或 NAS 上選擇放影片的資料夾，以大小與指紋自動配對這個專案所有鏡頭的影片",
  "relink.scanning": "正在搜尋資料夾…",
  "relink.pick": "選擇檔案…",
  "relink.loading": "讀取中…",
  "relink.linked": "✓ 已連結",
  "relink.hide": "先隱藏（畫面上仍可拖入影片）",
  "toast.folderMatched": "已在資料夾中配對 {n} 支影片（{shots} 個鏡頭）",
  "toast.folderNone": "資料夾中找不到這個專案的影片（依大小與指紋比對）",
  "toast.folderUnsupported": "這個瀏覽器不支援選擇資料夾，請逐一選擇檔案",
  "toast.folderFailed": "無法讀取資料夾：{detail}",
  "toast.projectAlreadyOpen": "「{name}」已經在左側清單中",
  "toast.savedTo": "已儲存：{name}",
  "export.playAfter": "輸出完成後自動播放",
  "player.title": "播放輸出：{name}",
  "drop.pickSeq": "選擇序列資料夾…",
  "drop.pickSeqTip": "選擇放 PNG 或 EXR 序列的資料夾（依檔名中的幀號排序）",
  "toast.noSequence": "「{name}」資料夾中找不到 PNG 或 EXR 序列",
  "error.open.exr": "無法讀取這個 EXR（可能是多圖層、深度或不支援的通道名稱；請輸出為單一圖層的 RGB／RGBA EXR）",
  "seq.fps": "幀率",
  "seq.frames": "{pattern}（{first}～{last}）",
  "seq.exrGamut": "EXR 顯示",
  "seq.gamut.rec709": "線性 Rec.709／sRGB",
  "seq.gamut.acescg": "ACEScg（AP1）",
  "seq.gamut.aces2065": "ACES2065-1（AP0）",
  "seq.transfer.srgb": "sRGB 曲線",
  "seq.transfer.rec709": "Rec.709 曲線",
  "seq.transfer.gamma24": "Gamma 2.4",
  "seq.transfer.linear": "線性（不轉換）",
  "seq.exposure": "曝光（級）",
  "seq.exrNote": "超過 1.0 的高光會被截斷",
  "drop.link": "貼上網址…",
  "drop.linkTip": "moonland 生成結果或參考影片（縮圖按右鍵 → 複製圖片網址）、Google 雲端硬碟（已開放檢視權限）或 YouTube（需啟動本機輔助程式）的影片網址；也可以在畫面上直接按 Ctrl+V 貼上",
  "drop.refetching": "正在從原始網址重新下載…",
  "link.title": "從網址加入影片",
  "link.label": "moonland（生成結果，或參考影片縮圖的圖片網址）、Google 雲端硬碟或 YouTube 的影片網址，可一次貼上多個（空白或換行分隔，依序放入空的格子）。YouTube 需要先啟動本機輔助程式。影片存放方式可在設定中選擇。",
  "toast.link.driveFolder": "Google 雲端硬碟的資料夾網址無法使用，請貼上單一影片檔的網址（在檔案上按右鍵 → 共用 → 複製連結）。",
  "toast.link.none": "沒有可辨識的網址。支援 moonland、Google 雲端硬碟與 YouTube 的影片網址。",
  "toast.link.downloading": "正在下載 {n} 支影片… {pct}%",
  "toast.link.done": "已下載 {n} 支影片",
  "toast.link.failed": "無法下載 {id}：{reason}",
  "toast.link.shotChanged": "已下載 {n} 支影片；因為已切換到其他鏡頭，沒有放入畫面",
  "error.remote.network": "連線失敗，請確認網路連線（公司內網可能無法連到外部網站）",
  "error.remote.notFound.moonland": "moonland 沒有提供這張卡片的影片位置（標示「來源」、帶攝影機圖示的卡片拖不出影片）。請按該卡片右上角的「⋮」→「前往源頭生成」，複製打開頁面的網址，在 AiComp 按 Ctrl+V 貼上",
  "error.remote.notFound.gdrive": "無法取得檔案，請確認已開放「知道連結的任何人」都能檢視，或檔案今天的下載次數已達上限",
  "error.remote.notVideo": "下載的內容不是影片檔",
  "toast.link.youtubeList": "請貼上單一 YouTube 影片的網址（播放清單與頻道網址無法使用）。",
  "error.remote.helper": "YouTube 需要本機輔助程式：請雙擊桌面的「AiComp YouTube helper」捷徑（或 AiComp 資料夾中的 helper/start-helper），保持視窗開啟後再貼上一次。還沒安裝請見安裝包的「安裝說明」。第一次連線時 Chrome 會詢問是否允許存取本機網路，請選允許",
  "error.remote.ytdlp": "本機輔助程式找不到 yt-dlp，請重新執行 helper/start-helper 完成安裝",
  "error.remote.youtube": "YouTube 下載失敗",
  "toast.link.dragImage": "拖入的是圖片，請拖入影片（生成結果、參考影片或素材庫中的影片）",
  "toast.link.dragNone": "無法辨識拖入的內容；請拖入 moonland 的影片、影片檔或影片網址",
  "align.target": "要對齊的版本（四格版面也可以在這裡切換）",
  "align.auto": "自動對齊",
  "align.autoTip": "在目前這一格比較「置中、拉伸、等比」與任意縮放估算，直接套用差異最小的結果（可復原）。載入尺寸和 A 不同的版本時會自動執行。",
  "align.points": "兩點對齊",
  "align.pointsTip": "在 A 與 B 的畫面上各點兩個相同的位置（例如眼角、招牌的角），依兩點計算 B 的縮放與位置；適用於畫面被縮放、裁切或外框改變、尺寸無法直接對上的影片",
  "align.points.guide": "依序在 A 與 {b} 上點相同的兩個位置（1、2 順序一致）：A {na}／2 · {b} {nb}／2。點上方畫面會移動準星，可在下方放大格點選微調（點在既有點附近會移動該點）。按 Esc 取消",
  "align.points.reset": "重新點選",
  "align.points.done": "已依兩點對齊：縮放 X {sx}% Y {sy}%，位移 {dx}, {dy}（可復原）",
  "align.points.bad": "兩點太近或 A、B 的點順序不一致，請重新點選（兩點盡量分開，例如畫面左上與右下）",
  "align.points.borrowed.x": "兩點幾乎上下排列，寬度縮放沿用高度縮放",
  "align.points.borrowed.y": "兩點幾乎水平排列，高度縮放沿用寬度縮放",
  "align.autoRunning": "自動對齊中…",
  "align.suggestion": "建議：",
  "align.notAligned": "尺寸和 A 不同，按「自動對齊」",
  "align.infoSame": "{id} {w}×{h}，與 A 相同",
  "align.manual": "手動微調",
  "card.summary": "{w}×{h} · {fps} fps · {n} 格 · {codec}",
  "card.offset": "時間偏移",
  "card.offsetValue": "{n} 格",
  "card.advanced": "進階設定",
  "srcmenu.tip": "{id} 的操作：替換、對齊、移除…",
  "srcmenu.replace": "替換影片…",
  "srcmenu.replaceSeq": "替換序列資料夾…",
  "srcmenu.replaceLink": "從網址替換…",
  "srcmenu.align": "對齊…",
  "srcmenu.swapA": "與 A 交換",
  "srcmenu.viewAlone": "單獨檢視這一格",
  "srcmenu.viewAll": "回到並排檢視",
  "srcmenu.remove": "移除 {id}",
  "spec.warn.resolutionAligned": "解析度不同（A {a}，此版本 {b}），已自動對齊",
  "settings.secLinks": "網址下載的影片",
  "settings.linkSave": "下載後",
  "settings.linkSave.folder": "存到資料夾",
  "settings.linkSave.none": "只在記憶體（不存檔）",
  "settings.linkFolderPick": "選擇資料夾…",
  "settings.linkFolderNow": "目前資料夾：{folder}",
  "settings.linkFolderNone": "尚未選擇",
  "toast.link.folderSet": "之後的影片會存到「{folder}」",
  "toast.link.noFolder": "沒有可寫入的資料夾，這次只在記憶體中比對（可在設定中選擇資料夾）",
  "toast.link.saveFailed": "無法存到「{folder}」，這次只在記憶體中比對",
  "card.diffs": "規格差異 {n} 項",
  "card.check": "檢查時間對齊",
  "toolbar.compareBase": "對照",
  "toolbar.compareBaseTip": "Wipe／疊加／閃切／差異要和哪一個比較：A（原始），或另一個 AI 版本（版本對版本比較）",
  "side.splitTip": "拖曳調整專案清單與工具面板的高度；雙擊回到自動",
  "badge.alignHint": "{id} 可能沒對齊：{what}",
  "align.hintShift": "偏移 {dx}, {dy} px",
  "align.hintScale": "縮放 {sx}% × {sy}%",
  "align.hintApply": "套用",
  "align.hintIgnore": "忽略",
  "export.alignWarn": "{ids} 可能尚未對齊，比較結果會有錯位；可在畫面上的提醒按「套用」",
  "toolbar.shot": "截圖",
  "toolbar.shotTip": "把目前畫面（含標籤與準星）另存成 PNG 圖片",
  "export.labelBefore": "原始（例如 Before）",
  "export.labelAfter": "AI 版本（例如 After）",
  "export.opening": "片頭",
  "export.openingNone": "無",
  "export.openingCard": "文字卡",
  "export.openingVideo": "指定影片",
  "export.introPick": "選擇影片…",
  "export.introFile": "{name}（{s} 秒）",
  "export.introNone": "尚未選擇片頭影片",
  "export.errIntro": "無法讀取片頭影片：{name}",
  "export.options": "選項",
  "export.saveTo": "存到",
  "export.folderPick": "選擇資料夾…",
  "export.folderTip": "輸出影片存放的資料夾（預設為專案資料夾）",
  "export.sumDur": "{s} 秒",
  "export.sumMb": "約 {mb} MB",
  "export.sumAudioOn": "聲音：{a}",
  "export.sumAudioOff": "無聲音",
  "export.replaceTitle": "檔案已存在",
  "export.replaceBody": "「{folder}」中已有「{name}」，要取代嗎？",
  "export.replace": "取代",
  "tree.menuTip": "專案：新增、開啟、儲存",
  "tree.saveAs": "另存新檔…",
  "tree.create": "建立",
  "tree.folder": "預設資料夾",
  "tree.folderNone": "尚未選擇",
  "tree.folderPick": "選擇資料夾…",
  "tree.folderNote": "下載的素材會存在這裡，輸出與截圖也預設存到這裡",
  "tree.folderSkipped": "未指定預設資料夾：下載的素材會存到設定中的資料夾",
  "dock.check": "檢查",
  "quality.run": "檢查 {id}",
  "quality.again": "重新檢查 {id}",
  "quality.sensTip": "靈敏度：越高會列出越輕微的問題",
  "quality.sens.low": "靈敏度 低",
  "quality.sens.medium": "靈敏度 中",
  "quality.sens.high": "靈敏度 高",
  "quality.range": "只檢查入點到出點",
  "quality.phaseFrames": "檢查掉格 {p}%…",
  "quality.phasePixels": "逐格比對 {p}%…",
  "quality.error": "檢查失敗：{detail}",
  "quality.stale": "版本、對齊或範圍已變更，請重新檢查",
  "quality.offsetHint": "時間可能沒對齊：建議偏移 {n} 格（素材分頁可套用）",
  "quality.none": "沒有發現值得檢查的地方",
  "quality.more": "還有 {n} 處",
  "quality.visTip": "在時間軸上顯示／隱藏",
  "quality.cat.frames": "掉格／重複格",
  "quality.cat.motion": "動作凍結／抖動",
  "quality.cat.seam": "處理接縫",
  "quality.cat.flicker": "閃爍",
  "quality.cat.color": "顏色",
  "quality.cat.clip": "截斷與影調",
  "quality.cat.banding": "色階斷層",
  "quality.cat.boiling": "紋理沸騰",
  "quality.k.freeze": "動作凍結：B 的動態只有 A 的 {p}%",
  "quality.k.jitter": "抖動：B 的動態是 A 的 {x} 倍",
  "quality.k.seam.color": "顏色突然改變（色差 ΔE {v}）",
  "quality.k.seam.luma": "畫面處理突然改變（差異 {v}）",
  "quality.k.flicker.luma": "亮度閃爍（{v} 階）",
  "quality.k.flicker.chroma": "色彩閃爍（ΔE {v}）",
  "quality.k.skin": "膚色偏移 ΔE {v}",
  "quality.k.skinHue": "膚色色相偏移 {v}°",
  "quality.k.cell": "局部色偏 ΔE {v}",
  "quality.k.sat": "飽和度下降 {v}%",
  "quality.k.high": "高光截斷（新增 {v}%）",
  "quality.k.low": "暗部截斷（新增 {v}%）",
  "quality.k.tone": "影調改變（{v}%）",
  "quality.k.banding": "平滑漸層出現色階斷層",
  "quality.k.boiling": "紋理逐格跳動",
  "quality.k.dupRun": "此版本從第 {b} 格起連續 {n} 格與前一格重複",
  "quality.desc.frames": "B 比 A 少了幾格、多了幾格，或同一格重複出現（只限逐格對應的版本）",
  "quality.desc.motion": "A 在動但 B 停住（凍結），或 B 晃動得比 A 厲害（抖動）",
  "quality.desc.seam": "B 的顏色或處理方式在某一格突然改變，常見於 AI 分段處理的接點",
  "quality.desc.flicker": "亮度或顏色逐格來回跳動，B 比 A 明顯",
  "quality.desc.color": "膚色偏移、局部色偏、飽和度下降",
  "quality.desc.clip": "B 新增的過曝、死黑，或整體影調改變",
  "quality.desc.banding": "平滑漸層（天空、牆面）出現一階一階的斷層",
  "quality.desc.boiling": "細紋理（皮膚、頭髮、草地）每格都在變，看起來像在滾動",
  "settings.language": "Language",
  "settings.secGeneral": "一般",
  "settings.linkFolder": "資料夾",
  "color.hint.untagged": "這個版本沒有色彩標記，目前當作 {b}；A 是 {a}，顏色比對可能不準",
  "color.hint.differs": "色彩標記與 A 不同（A：{a}，這個版本：{b}）；若是標錯，顏色會看起來偏掉",
  "color.hint.apply": "比照 A（{a}）",
  "params.bandTip": "差異的頻段",
  "params.band.all": "全部",
  "params.band.low": "光影",
  "params.band.high": "細節",
  "params.band.allTip": "整個畫面的差異",
  "params.band.lowTip": "只比光線與顏色（模糊後的畫面），細節改變不顯示（F-05.6）",
  "params.band.highTip": "只比細節與結構（扣掉光線與顏色），整體調色不顯示，適合看臉部細節有沒有被改（F-05.7）",
  "quality.all": "檢查整個專案",
  "quality.allTip": "依序打開每個鏡頭，檢查還沒檢查過（或已變更）的版本；無法直接開啟影片的鏡頭會略過",
  "quality.batch": "鏡頭 {i}／{n}",
  "quality.allDone": "整個專案檢查完成：檢查了 {n} 個版本，略過 {s} 個鏡頭",
  "tree.qcTip": "自動品質檢查的結果（目前靈敏度）",
  "tree.qcFound": "⚠ {n} 處",
  "tree.qcNone": "✓ 已檢查",
  "sheet.button": "輸出問題截圖",
  "sheet.tip": "每個可疑段落一格：A｜B 與放大的問題位置，每張 6 格，存成 PNG 給修改的人",
  "sheet.file": "問題截圖",
  "sheet.progress": "製作問題截圖 {d}／{n}…",
  "sheet.done": "已輸出 {n} 張問題截圖到「{folder}」",
  "sheet.downloads": "下載資料夾",
  "sheet.wholeFrame": "（整個畫面的問題，沒有特定位置）",
  "drop.transcoding": "本機輔助程式轉檔中 {p}%（ProRes 等瀏覽器無法播放的格式會轉成 H.264）…",
  "toast.transcoded": "已轉成 H.264：{name}",
  "toast.transcodeFailed": "無法轉檔 {name}：{reason}",
  "error.transcode.helperOld": "本機輔助程式太舊，請從安裝包重新安裝",
  "error.transcode.ffmpeg": "本機輔助程式找不到 ffmpeg",
  "error.transcode.failed": "ffmpeg 轉檔失敗",
  "error.transcode.noHelper": "需要本機輔助程式：請雙擊桌面的「AiComp YouTube helper」捷徑，保持視窗開啟後再拖入一次",
  "quality.cat.face": "臉部",
  "quality.desc.face": "偵測人臉後比對 A 與 B：五官位置偏移、B 的臉不見了、眨眼或嘴型不一致；側臉段落容易出錯也會列出（瀏覽器內的臉部模型，不連網）",
  "quality.k.face.drift": "{part}位置偏移（兩眼距離的 {v}%）",
  "quality.k.face.lost": "B 的臉不見了（A 有臉）",
  "quality.k.face.blink": "眨眼與 A 不同（差 {v}%）",
  "quality.k.face.mouth": "嘴巴開合與 A 不同（差 {v}%）",
  "quality.k.face.turned": "側臉：AI 最容易出錯的角度，建議仔細看",
  "quality.part.eyes": "眼睛",
  "quality.part.brows": "眉毛",
  "quality.part.nose": "鼻子",
  "quality.part.mouth": "嘴巴",
  "quality.part.jaw": "下顎輪廓",
  "ai.secTitle": "分析（雲端）",
  "ai.key": "Anthropic API Key",
  "ai.keyPlaceholder": "sk-ant-…（只存在這台電腦的瀏覽器）",
  "ai.keyClear": "清除",
  "ai.model": "模型",
  "ai.model.sonnet": "Claude Sonnet 5.5（預設，較快較省）",
  "ai.model.opus": "Claude Opus 5.5（較準，較貴）",
  "ai.notice": "使用「分析」時，選定格數的 A、B 畫面（縮小到長邊 1024 px）會傳到 Anthropic 的伺服器分析，費用由這個 API Key 的帳號支付。請確認素材可以外傳。",
  "ai.briefPlaceholder": "這次 AI 做了什麼（選填），例如：換背景、換衣服",
  "ai.briefTip": "告訴 AI 哪些改變是刻意的，避免被當成問題列出；存在這個鏡頭",
  "ai.button": "分析",
  "ai.paused": "暫停使用（評估中）",
  "ai.empty": "還沒有分析結果",
  "dock.analysis": "分析",
  "ai.sendNote": "⚠ 會把 8 格的 A、B 畫面傳到 Anthropic（雲端）分析",
  "ai.running": "分析中 {d}／{n}…",
  "ai.done": "分析完成：列出 {n} 個問題",
  "ai.failed": "分析失敗：{reason}",
  "ai.error.noKey": "請先在設定輸入 Anthropic API Key",
  "ai.error.key": "API Key 無效或沒有權限",
  "ai.error.rate": "請求太頻繁，稍後再試",
  "ai.error.network": "連不到 Anthropic（公司網路可能擋住了 api.anthropic.com）",
  "ai.error.api": "Anthropic 回應錯誤",
  "quality.cat.ai": "分析",
  "quality.desc.ai": "由 Claude 看 A、B 畫面，列出手指、臉、文字、物件、邊緣等問題；按「分析」才會執行，會把畫面傳到雲端",
  "quality.k.ai.none": "（沒有說明）",
};

export const EN: Record<string, string> = {
  "app.demoNotice": "UI demo · synthetic frames, no decoding",
  "project.untitled": "Untitled project",
  "toolbar.open": "Open…",
  "toolbar.save": "Save",
  "toolbar.saveTip": "Save the current project (Ctrl+S; Shift = Save As)",
  "toolbar.export": "Export",
  "toolbar.addVersion": "+ Add version",
  "toolbar.dock": "Panel",
  "toolbar.settings": "Settings",
  "toolbar.help": "Help",
  "toolbar.crosshair": "Crosshair",
  "toolbar.rightSource": "Right side",
  "toolbar.align": "Align…",
  "layout.label": "Layout",
  "layout.sbs": "Side by side",
  "layout.sbs-zoom": "Side by side + zoom",
  "layout.quad": "Quad",
  "layout.single": "Single",
  "mode.label": "Compare",
  "mode.sbs": "Side by side",
  "mode.wipe": "Wipe",
  "mode.overlay": "Overlay",
  "mode.flicker": "Flicker",
  "mode.diff": "Difference",
  "params.angle": "Angle",
  "params.opacity": "AI output opacity",
  "params.flickerInfo": "Switches {hz}× per second (change in Settings)",
  "params.gain": "Gain",
  "params.gray": "Gray",
  "params.heat": "Heat",
  "params.luma": "Luma only",
  "view.fit": "Fit",
  "view.actual": "100%",
  "zoom.label": "Zoom",
  "zoom.down": "Zoom out one step (-)",
  "zoom.up": "Zoom in one step (+)",
  "dur.frame": "1 frame",
  "dur.sec": "{s} s",
  "synth.A": "Original",
  "synth.B1": "Version 1 (scene swap)",
  "synth.B2": "Version 2 (relight)",
  "synth.B3": "Version 3 (fabricated detail)",
  "badge.display": "Display {p}%",
  "badge.zoom": "Zoom {p}%",
  "badge.outOfRange": "{id} out of range",
  "badge.grid": "{id} comparison grid ×{p}%",
  "badge.offset": "{id} offset {n} fr",
  "badge.proxy": "Proxy frames while playing (do not judge flicker or texture)",
  "badge.dropping": "Dropping frames",
  "badge.flickerNow": "Showing: {id}",
  "badge.adjust": "View adjustment on",
  "badge.adjustB": "only on {id}",
  "badge.channel": "Channel: {c}",
  "badge.texture": "Gray texture view",
  "align.mode.center": "Centre, no scaling",
  "align.mode.stretch": "Stretch to A",
  "align.mode.fit": "Fit (keep aspect)",
  "align.mode.topleft": "Top-left",
  "align.mode.manual": "Manual",
  "align.mode.identity": "Reference",
  "align.title": "Align",
  "align.info": "{id} {bw}×{bh} → A {aw}×{ah} ({p}%)",
  "align.needB": "Load A and an AI output first",
  "align.sameSize": "Same size as A; usually no alignment needed",
  "align.estimating": "Estimating…",
  "align.apply": "Apply",
  "align.applied": "Applied:",
  "align.reset": "Reset to centre",
  "align.dx": "X offset (A px)",
  "align.dy": "Y offset (A px)",
  "align.sx": "Width scale (%)",
  "align.sy": "Height scale (%)",
  "align.scale": "scale X {sx}% Y {sy}%",
  "align.crop": "cropped {v}",
  "align.gap": "black {v}",
  "align.showDiff": "Show difference",
  "align.note": "The comparison grid is always A’s pixel grid (D-37). Parts of an AI output outside A are cropped, missing areas show black.",
  "edge.l": "L",
  "edge.r": "R",
  "edge.t": "T",
  "edge.b": "B",
  "composite.wipe": "Wipe: {a} | {b}",
  "composite.overlay": "Overlay: {a} + {b} {p}%",
  "composite.flicker": "Flicker: {a} ⇄ {b} ({hz} Hz)",
  "composite.diff": "Difference: |{a} − {b}| ×{g}",
  "drop.A": "Drop the original here (A)",
  "drop.B": "Drop an AI output here ({id})",
  "drop.hint": "Drop several videos at once (sorted by name into A, B, C, D), a folder with a PNG / EXR sequence, or an .acproj project; drag a video from a moonland page onto any pane, or press Ctrl+V to paste a moonland / Google Drive / YouTube video link.",
  "drop.pick": "Choose video…",
  "drop.synth": "Use synthetic demo frames",
  "timeline.play": "Play (Space)",
  "timeline.pause": "Pause (Space)",
  "timeline.start": "Go to start (Home)",
  "timeline.end": "Go to end (End)",
  "timeline.stepBack": "Step back (←)",
  "timeline.stepFwd": "Step forward (→)",
  "timeline.tcToggle": "Click to switch: embedded timecode / from zero",
  "timeline.tcEmbedded": "Embedded timecode",
  "timeline.tcZero": "From zero",
  "timeline.noEmbedded": "No embedded timecode, counting from zero",
  "timeline.offset": "{id} offset {n} fr",
  "timeline.noB": "No AI output loaded",
  "timeline.offDown": "Selected version offset -1 frame ([)",
  "timeline.offUp": "Selected version offset +1 frame (])",
  "timeline.length": "{n} frames · {fps} fps",
  "timeline.in": "In",
  "timeline.inTip": "Set in point (I)",
  "timeline.out": "Out",
  "timeline.outTip": "Set out point (O)",
  "timeline.clearIO": "Clear",
  "loop.loop": "Loop",
  "loop.once": "Once",
  "loop.pingpong": "Ping-pong",
  "audio.label": "Audio",
  "audio.none": "(no audio)",
  "audio.mute": "Mute",
  "dock.adjust": "Adjust",
  "dock.mask": "Mask",
  "dock.info": "Media",
  "adjust.enable": "View adjustment on (V)",
  "adjust.linked": "Link all sources",
  "adjust.presets": "Presets",
  "preset.shadows": "Shadows",
  "preset.highlights": "Highlights",
  "preset.banding": "Banding",
  "adjust.exposure": "Exposure (stops)",
  "adjust.gamma": "Gamma",
  "adjust.levels": "Levels",
  "adjust.inBlack": "Input black",
  "adjust.inWhite": "Input white",
  "adjust.mid": "Midtones",
  "adjust.outBlack": "Output black",
  "adjust.outWhite": "Output white",
  "adjust.reset": "Reset all",
  "adjust.viewTitle": "View",
  "adjust.channel": "Channel",
  "channel.rgb": "RGB",
  "channel.r": "R",
  "channel.g": "G",
  "channel.b": "B",
  "channel.luma": "Luma",
  "adjust.texture": "Gray texture view (G): boosts local contrast to see pores and wrinkles vanish or swim",
  "adjust.note": "Changes the display only, not the videos. Not applied to exports by default.",
  "info.specTitle": "Detailed spec comparison",
  "info.none": "No sources loaded",
  "info.file": "File",
  "info.synth": "Synthetic demo",
  "info.image": "Image",
  "info.size": "Resolution",
  "info.codec": "Codec",
  "info.fps": "Frame rate",
  "info.frames": "Frames",
  "info.bitDepth": "Bit depth",
  "info.chroma": "Chroma",
  "info.color": "Colour space",
  "info.range": "Range",
  "info.tc": "Timecode",
  "info.noTc": "None",
  "info.audio": "Audio",
  "info.noAudio": "None",
  "info.vfr": "Variable fps",
  "info.yes": "Yes",
  "info.no": "No",
  "warn.size": "{id} is {b}, A is {a}: check the alignment (Align…)",
  "warn.fps": "{id} runs at {b} fps, A at {a}: frame rate changed; still matched frame by frame when counts agree",
  "warn.frames": "{id} has {b} frames, A has {a}: the missing part shows black",
  "warn.bitDepth": "{id} is {b}-bit, A is {a}-bit: banding may appear",
  "warn.color": "{id} is tagged {b}, A is {a}: an apparent colour cast may not be the AI",
  "warn.tc": "{id} has no timecode (A does)",
  "warn.audio": "{id} has no audio (A does)",
  "export.title": "Export",
  "export.template": "Template",
  "export.tpl.sbs": "Side by side",
  "export.tpl.sbs-zoom": "Side by side + zoom",
  "export.tpl.quad": "Quad",
  "export.tpl.wipe": "Animated wipe",
  "export.tpl.current": "Current view",
  "export.tpl.mask": "Mask (black & white)",
  "export.labels": "Labels",
  "export.range": "Range",
  "export.rangeAll": "Whole clip",
  "export.rangeIO": "In to out",
  "export.codec": "Codec",
  "export.half": "Half size (for sharing)",
  "export.sumSize": "Frame size {w}×{h}",
  "export.sumScaled": "Larger than 3840×2160, scaled to {p}%",
  "export.sumFrames": "{n} frames ({s} s)",
  "export.go": "Export",
  "export.goMaskFrame": "Save this frame's mask PNG",
  "settings.title": "Settings",
  "settings.secView": "Viewing",
  "settings.secDemo": "Demo only",
  "settings.flickerHz": "Flicker rate",
  "settings.timecode": "Timecode display",
  "settings.frameBase": "First frame number",
  "settings.degrade": "When decoding falls behind",
  "settings.degradeSmooth": "Smooth first (proxy frames)",
  "settings.degradeQuality": "Quality first (drop frames)",
  "settings.centerMark": "Outline the centre pixel in zoom panes",
  "settings.b1Size": "B output size",
  "size.native": "1920×1080 (same as A)",
  "size.pad": "1988×1088 padded",
  "size.stretch": "1988×1088 stretched",
  "settings.simulateDegrade": "Simulate degrade badge while playing",
  "settings.dpr": "devicePixelRatio {v} · canvas {w}×{h} physical px",
  "settings.loadDemo": "Reload synthetic demo",
  "settings.clearAll": "Clear all sources",
  "toast.modeOneToOne": "Compare modes work in one-to-one layouts only",
  "toast.modeQuad": "The quad layout has overlay and flicker; for wipe and difference switch to side by side or side by side + zoom",
  "toast.noSource": "{id} is not loaded",
  "toast.added": "Added {id} (synthetic demo)",
  "toast.notImage": "The demo only accepts images or .acproj; the real app will take MP4",
  "toast.loadFailed": "Cannot read {name}",
  "toast.loaded": "Loaded {n} image(s)",
  "toast.stillSaved": "PNG saved",
  "toast.exportDemo": "The demo does not actually export video",
  "toast.saved": "Project file saved",
  "toast.opened": "Opened {name}",
  "toast.openFailed": "Could not read the project file",
  "toast.audioDemo": "The demo has no sound; the real app plays audio at 1x forward only",
  "toast.noDownload": "The shared copy cannot download files; saving works when the demo runs locally",
  "help.title": "Help",
  "help.keysTitle": "Shortcuts",
  "help.mouseTitle": "Mouse",
  "help.demoTitle": "About this demo",
  "help.tryTitle": "Things to try",
  "key.altArrows": "Alt+Arrows",
  "help.k.play": "Play / pause",
  "help.k.step": "Step back / forward",
  "help.k.step10": "Back / forward 10 frames",
  "help.k.startEnd": "Go to start / end",
  "help.k.jkl": "Reverse faster / pause / forward faster",
  "help.k.inOut": "Set in / out point",
  "help.k.offset": "Selected version offset -1 / +1 frame",
  "help.k.sources": "Tap: choose the version on the right (in Single, choose the source); hold: full screen until released",
  "help.k.layout": "Cycle layouts",
  "help.k.mode": "Cycle compare modes",
  "help.k.diff": "Toggle difference",
  "help.k.fit": "Top view: fit to window",
  "help.k.actual": "Top view: 100% physical pixels",
  "help.k.fullscreen": "Full screen with UI hidden",
  "help.k.crosshair": "Hide / show crosshair",
  "help.k.level": "Zoom one step (100%–3000%)",
  "help.k.moveCross": "Move crosshair 1 px; with Shift 10 px",
  "help.k.adjust": "Toggle view adjustment",
  "help.k.preset": "Cycle view adjustment presets",
  "help.k.texture": "Gray texture view",
  "help.k.save": "Save project file",
  "help.k.help": "Toggle this help",
  "help.k.esc": "Close dialogs / leave full screen / back to crosshair tool",
  "help.mouse1": "Click the top view: move the crosshair there, shown on both sides",
  "help.mouse2": "Drag in the top view: move the crosshair continuously",
  "help.mouse3": "Drag in a zoom pane: pan the zoomed position; wheel changes zoom",
  "help.mouse4": "At 100%, right- or middle-drag: pan the top view",
  "help.mouse5": "Wipe: drag the round handle to move the divider",
  "help.mouse6": "Drag the bar between top and bottom to resize",
  "help.mouse7": "Drop a video on a cell to load or replace that source; drop an .acproj to open it",
  "help.mouse8": "Double-click an AI output in the quad layout to compare it one-to-one with A (F-04.5)",
  "help.demo1": "Frames are generated synthetically: 120 frames played at 24 fps; the burned-in number is that source's own frame",
  "help.demo2": "B simulates a scene swap: new background, plastic skin, warmer skin, hair edge halo, earring removed; its output size is 1988×1088 by default (change in Settings)",
  "help.demo3": "C simulates a relight: warm cast, gaze shifted, and 10 frames shorter than A",
  "help.demo4": "D simulates fabricated detail: freckles, heavier pores, garbled sign text; tagged BT.601",
  "help.demo5": "Scopes and the sampler work in 8-bit; the person mask comes straight from the synthetic person, the real app will use a segmentation model",
  "help.demo6": "Not included: video decoding, sound, real video export (still PNG and a single mask frame do save)",
  "help.try1": "Open Align… to see how B's 1988×1088 lines up with A; compare \"Centre, no scaling\" and \"Stretch to A\" in the difference view",
  "help.try2": "Click the face, eyes and hair edge and compare both sides below at 400%–1000%",
  "help.try3": "Scopes tab: switch between waveform, parade, vector, histogram and codes; set Region to Zoom area to look near the crosshair",
  "help.try4": "Adjust tab: apply Shadows, change Levels, switch channels and the gray texture view",
  "help.try5": "On the Notes tab, pick the box tool and draw a box with text, set its frame range, and watch it on the timeline",
  "help.try6": "Mask tab: compute the person mask, then try focus and \"difference inside the person only\"",
  "help.try7": "Export…: look at the options for the four kinds of output",
  "project.readOnly": "read-only (newer project file)",
  "project.warn.newer": "This project was saved by a newer AiComp and is opened read-only; use Save As to keep your changes.",
  "toolbar.openTip": "Open an .acproj project, e.g. one a colleague put on the NAS (or drop it on the viewer)",
  "toolbar.undo": "Undo (Ctrl+Z)",
  "toolbar.redo": "Redo (Ctrl+Shift+Z)",
  "toolbar.zoomDiff": "Zoom diff",
  "toolbar.zoomDiffTip": "Show the difference in the right zoom pane (F-06.6)",
  "toolbar.zoomGrid": "Grid",
  "toolbar.zoomGridTip": "Semi-transparent grid in the zoom panes, one cell per 10 pixels of A, at the same position on both sides; from 2000 % the intersections show their coordinates",
  "layout.sbs.tip": "A | version side by side",
  "layout.sbs-zoom.tip": "Side by side on top, crosshair zoom below (main workflow)",
  "layout.quad.tip": "2×2: A, B, C, D",
  "layout.single.tip": "One cell; switch sources with number keys",
  "mode.sbs.tip": "Side-by-side comparison",
  "mode.wipe.tip": "Draggable split line with adjustable angle",
  "mode.overlay.tip": "The version over A with opacity",
  "mode.flicker.tip": "Alternate A and the version (rate in Settings)",
  "mode.diff.tip": "Absolute difference between A and the version (D)",
  "view.fitTip": "Fit the top panes (F)",
  "view.actualTip": "Top panes at 100% physical pixels (0); right-drag to pan",
  "timeline.gotoTip": "Go to a frame number or timecode (Ctrl+G)",
  "timeline.originalOnly": "Original frames only",
  "timeline.speed": "Playback speed (0.25×–2×)",
  "audio.onlyAt1x": "Audio plays only at 1× forward",
  "goto.title": "Go to",
  "goto.label": "Frame or timecode",
  "goto.hint": "e.g. 120 or 01:00:05:12 (in the current timecode mode)",
  "goto.go": "Go",
  "goto.invalid": "Not recognised or out of range",
  "align.freeResult": "X {sx}% Y {sy}% · shift {dx}, {dy}",
  "align.errorValue": "Mean difference {e} (lower is better)",
  "align.shift": "shift {dx}, {dy}",
  "align.mode.center.tip": "Padded or cropped around (no resampling)",
  "align.mode.stretch.tip": "The whole picture was resized",
  "align.mode.fit.tip": "Scaled keeping aspect, with borders",
  "align.mode.topleft.tip": "Padded on the right and bottom only",
  "badge.alignDiff": "Aligning: showing the difference",
  "badge.approximate": "{id} time-based mapping (not frame-accurate)",
  "badge.decoding": "Decoding…",
  "badge.frameError": "{id} frame {n} failed to decode",
  "badge.noCounterpart": "A has no counterpart (generated frame)",
  "badge.zoomDiff": "{id} showing the difference",
  "badge.proxyPaused": "Proxy (full resolution loading)",
  "cap.title": "This browser cannot run AiComp",
  "cap.body": "Use the latest Chrome or Edge, opened over HTTPS or localhost. Missing:",
  "cap.secure": "Secure context (HTTPS or localhost)",
  "cap.webcodecs": "WebCodecs (video decoding)",
  "cap.webgl2": "WebGL2 (rendering)",
  "cap.workers": "Web Workers and OffscreenCanvas",
  "cap.indexeddb": "IndexedDB (autosave)",
  "drop.loading": "Loading…",
  "drop.relink": "Drop the video for {id}: {name}",
  "drop.relinkHint": "The project stores only file identity; the fingerprint is checked after you drop the file.",
  "drop.error": "Cannot use {name}",
  "drop.transcodeHint": "With the local helper (YouTube helper) running this is converted automatically; or convert to H.264 or HEVC with HandBrake or Media Encoder",
  "error.open.noVideo": "No video track in the file",
  "error.open.undecodable": "This browser cannot decode {codec} (e.g. ProRes, DNxHR, some 4:2:2 or 10-bit H.264)",
  "error.open.unreadable": "The file cannot be parsed (unsupported container or damaged)",
  "error.open.unsupportedCodec": "Unsupported codec ({codec})",
  "error.project.invalid": "This is not a valid AiComp project",
  "error.project.parse": "The project file is malformed",
  "error.project.version": "This project version cannot be converted",
  "error.save": "Saving failed: {detail}",
  "export.cancel": "Cancel",
  "help.aboutTitle": "About",
  "help.about1": "All decoding, comparison and export run in this browser; videos, frames and masks are never uploaded.",
  "help.about2": "The picture always shows the correct frame; when playback cannot keep up it uses proxies or drops frames, as set, and says so in the corner.",
  "help.about3": "Paused frames are converted by our own shader from the original code values; playback uses the GPU path with a colour-matrix correction.",
  "help.about4": "Hardware-decoded 10-bit HEVC only exposes browser-converted 8-bit data, which is noted.",
  "help.about5": "The self-test page (Settings → Self-test) checks frame accuracy on this machine with barcode test clips.",
  "help.k.stepBack": "Step back one frame (one tick when interpolated)",
  "help.k.stepFwd": "Step forward one frame",
  "help.k.back10": "Back 10 frames",
  "help.k.fwd10": "Forward 10 frames",
  "help.k.start": "Go to start (or in point)",
  "help.k.end": "Go to end (or out point)",
  "help.k.j": "Play reverse (press again to speed up)",
  "help.k.k": "Pause",
  "help.k.l": "Play forward (press again to speed up)",
  "help.k.in": "Set in point",
  "help.k.out": "Set out point",
  "help.k.offDown": "Selected version offset −1 frame",
  "help.k.offUp": "Selected version offset +1 frame",
  "help.k.goto": "Go to frame or timecode",
  "help.k.zoomIn": "Zoom level up",
  "help.k.zoomOut": "Zoom level down",
  "help.k.crossLeft": "Crosshair left 1 px",
  "help.k.crossRight": "Crosshair right 1 px",
  "help.k.crossUp": "Crosshair up 1 px",
  "help.k.crossDown": "Crosshair down 1 px",
  "help.k.crossLeft10": "Crosshair left 10 px",
  "help.k.crossRight10": "Crosshair right 10 px",
  "help.k.crossUp10": "Crosshair up 10 px",
  "help.k.crossDown10": "Crosshair down 10 px",
  "help.k.undo": "Undo",
  "help.k.redo": "Redo",
  "info.sourcesTitle": "Sources",
  "info.container": "Container",
  "info.duration": "Duration",
  "info.bitrate": "Video bitrate",
  "info.gop": "Longest GOP",
  "info.mapping": "Frame mapping",
  "info.decodePath": "Decode path",
  "info.decodeRaw": "raw code values",
  "info.decodeBrowser": "browser-converted (8-bit)",
  "info.auto": "Auto",
  "info.colorOverride": "Colour tags",
  "info.displayNamePh": "Display name (e.g. Version 1 Topaz)",
  "info.replace": "Replace…",
  "info.remove": "Remove",
  "info.swapA": "Swap with A",
  "mapping.one-to-one": "Frame by frame",
  "mapping.ratio": "{n}× interpolation",
  "mapping.time": "By time (not frame-accurate)",
  "mapping.reason.same": "Same frame count and rate",
  "mapping.reason.sameRateDiffCount": "Same rate, different length",
  "mapping.reason.ratio": "Integer interpolation",
  "mapping.reason.time": "Non-integer rate change",
  "preset.customName": "Custom {n}",
  "adjust.savePreset": "Save as preset",
  "settings.alignDiff": "Show the difference while aligning",
  "settings.copyDiag": "Copy diagnostics",
  "settings.exportPreset": "Export team preset…",
  "settings.importPreset": "Import team preset…",
  "settings.perf": "Performance",
  "settings.sampling": "Zoom sampling",
  "settings.samplingNearest": "Nearest (true pixels)",
  "settings.samplingSmooth": "Smooth",
  "settings.secSystem": "System",
  "settings.secTeam": "Team presets and shortcuts",
  "settings.selftest": "Self-test…",
  "settings.shortcuts": "Customise shortcuts…",
  "settings.version": "AiComp {v} · built {d}",
  "shortcuts.title": "Customise shortcuts",
  "shortcuts.hint": "Click a key button, then press the new key; Esc cancels. Stored on this computer and included in team presets.",
  "shortcuts.action": "Action",
  "shortcuts.key": "Key",
  "shortcuts.press": "Press a key…",
  "shortcuts.reserved": "That key is reserved by the browser",
  "shortcuts.reset": "Reset all",
  "spec.warn.aspect": "Aspect ratio differs (A {a}, this version {b})",
  "spec.warn.audioFormat": "Audio format differs (A {a}, this version {b})",
  "spec.warn.audioLength": "Audio length differs (A {a} s, this version {b} s)",
  "spec.warn.audioMissing": "No audio track (A has one)",
  "spec.warn.audioOnlyB": "Has audio but A does not",
  "spec.warn.bitDepth": "Bit depth differs (A {a}-bit, this version {b}-bit); banding may appear",
  "spec.warn.chroma": "Chroma subsampling {cs}",
  "spec.warn.chromaDiff": "Chroma subsampling differs (A {a}, this version {b})",
  "spec.warn.colorTags": "Colour primaries or transfer tags differ from A",
  "spec.warn.fps": "Frame rate differs (A {a}, this version {b})",
  "spec.warn.fpsMicro": "Frame rate changed (A {a}, this version {b}); still matched frame by frame (D-20)",
  "spec.warn.frameCount": "{b} frames, expected {a} (diff {diff}); out-of-range shows black, an offset may be needed",
  "spec.warn.hdr": "HDR (PQ/HLG) detected: accurate HDR display is not supported yet (C-08)",
  "spec.warn.interlaced": "Interlaced video detected",
  "spec.warn.matrix": "Colour matrix tags differ (A {a}, this version {b}): a colour shift may not be caused by the AI (C-04)",
  "spec.warn.noColorTags": "No colour tags; defaults used (BT.709 limited for HD, C-02)",
  "spec.warn.par": "Non-square pixels (PAR {par})",
  "spec.warn.range": "Range differs (A {a}, this version {b})",
  "spec.warn.resolution": "Resolution differs (A {a}, this version {b}): check the alignment (Align…)",
  "spec.warn.rotation": "Rotation flag in the container ({deg}°)",
  "spec.warn.timeMapping": "Time-based mapping: not frame-accurate",
  "spec.warn.timecode": "Start timecode differs (A {a}, this version {b})",
  "spec.warn.undecodable": "The browser cannot decode {codec}",
  "spec.warn.vfr": "Variable frame rate affects frame matching",
  "toast.diagCopied": "Diagnostics copied (no video content or file paths)",
  "toast.diagFailed": "Could not write to the clipboard",
  "toast.fingerprint": "{id}: {name} differs from the file in the project; alignment and settings may not match",
  "toast.preset": "View adjustment: {name}",
  "toast.presetExported": "Team preset exported",
  "toast.presetImported": "Imported {n} presets",
  "toast.presetInvalid": "Not a valid team preset file",
  "toast.presetSaved": "Saved preset “{name}”",
  "toast.readOnly": "Read-only project: use Save As",
  "export.errCodec": "This browser cannot encode {codec} at {w}×{h}; use H.264 or Half size",
  "export.burnScaled": "Output scaled to {p}%",
  "export.burnAdjusted": "View adjustment applied",
  "export.slateTitle": "Title card",
  "export.slateSubtitle": "Subtitle",
  "export.bitrate": "Bitrate (Mbps)",
  "export.bitrateAuto": "Auto (high)",
  "export.needA": "Load A first",
  "export.failed": "Export failed: {detail}",
  "export.cancelled": "Export cancelled",
  "export.done": "Export finished ({s} s)",
  "export.maxRate": "Output at the interpolated frame rate (A frames repeat)",
  "export.audio": "Include the selected audio",
  "temporal.title": "Time alignment and frame checks",
  "temporal.hint": "Compares every frame of A and this version to suggest a time offset (a suggestion only; dropped and repeated frames are in the Check tab)",
  "temporal.onlyOneToOne": "Only for frame-by-frame mapped versions",
  "temporal.analyse": "Analyse",
  "temporal.again": "Analyse again",
  "temporal.running": "Analysing {p}%…",
  "temporal.suggest": "Suggested {id} offset {n} frames",
  "temporal.confidence": "(confidence {c})",
  "temporal.lowConfidence": "Too little motion; the suggestion is unreliable — please check by eye",
  "temporal.apply": "Apply offset",
  "temporal.none": "No offset could be determined",
  "temporal.noEvents": "No dropped, inserted or repeated frames found",
  "temporal.ev.drop": "{n} frame(s) missing here (this version's frame {b})",
  "temporal.ev.insert": "{n} extra frame(s) here (this version's frame {b})",
  "temporal.ev.duplicate": "This version's frame {b} repeats the previous frame",
  "error.glLost": "The GPU context was lost; recovering automatically…",
  "error.glRestored": "Display restored",
  "error.permission": "Cannot read {name} for {id} (permission denied or file moved); drop it again",
  "params.vertical": "Stacked",
  "common.ok": "OK",
  "common.cancel": "Cancel",
  "toolbar.addVersionTip": "Add an AI version to this shot",
  "toolbar.crosshairTip": "Crosshair (C hides it temporarily)",
  "side.collapse": "Collapse the project list",
  "side.expand": "Expand the project list",
  "tree.title": "Projects",
  "tree.newProject": "+ New",
  "tree.newProjectTip": "Create a new project",
  "tree.newProjectTitle": "New project",
  "tree.projectName": "Project name",
  "tree.search": "Search projects or shots",
  "tree.legendLinked": "Videos linked",
  "tree.legendRelink": "Videos needed",
  "tree.legendEmpty": "No videos",
  "tree.untitledShot": "Shot {n}",
  "tree.shot": "Shot",
  "tree.copySuffix": " copy",
  "tree.notSaved": "Not saved yet",
  "tree.dirtyTip": "Unsaved changes",
  "tree.more": "More (or right-click)",
  "tree.addShot": "+ Add shot",
  "tree.noMatch": "No matching project or shot",
  "tree.versions": "A + {n} versions",
  "tree.videos": "{n} videos",
  "tree.status.linked": "Videos linked",
  "tree.status.relink": "Videos needed",
  "tree.status.empty": "No videos",
  "tree.status.loading": "Loading",
  "tree.menu.save": "Save",
  "tree.menu.saveAs": "Save as…",
  "tree.menu.mediaFolder": "Choose media folder…",
  "tree.menu.rename": "Rename",
  "tree.menu.addShot": "Add shot",
  "tree.menu.dupProject": "Duplicate project",
  "tree.menu.dupShot": "Duplicate shot (with settings)",
  "tree.menu.moveShot": "Move to another project…",
  "tree.menu.forget": "Choose the videos again",
  "tree.menu.up": "Move up",
  "tree.menu.down": "Move down",
  "tree.menu.deleteShot": "Delete shot",
  "tree.menu.close": "Close (remove from the list)",
  "tree.moveTitle": "Move to another project",
  "tree.deleteTitle": "Delete shot",
  "tree.deleteBody": "Delete \"{name}\"? Its settings are removed from the project (written to the file when you save; the videos are not touched).",
  "tree.delete": "Delete",
  "tree.closeTitle": "Close project",
  "tree.closeBody": "\"{name}\" has unsaved changes. The project file itself is not deleted.",
  "tree.closeSave": "Save and close",
  "tree.closeDiscard": "Close without saving",
  "relink.title": "Videos for \"{name}\"",
  "relink.desc": "The project file stores only each video's name, size and fingerprint, not the video. Choose the media folder once and the videos of every shot in this project are matched automatically; or pick the files one by one, or drop them on the viewer.",
  "relink.allow": "Allow access to the videos",
  "relink.allowTip": "This computer remembers the videos; the browser needs your permission again",
  "relink.folder": "Choose media folder…",
  "relink.folderTip": "Pick the folder with the videos (local or NAS); every shot of this project is matched by size and fingerprint",
  "relink.scanning": "Searching the folder…",
  "relink.pick": "Choose file…",
  "relink.loading": "Loading…",
  "relink.linked": "✓ Linked",
  "relink.hide": "Hide for now (you can still drop videos on the viewer)",
  "toast.folderMatched": "Matched {n} videos in the folder ({shots} shots)",
  "toast.folderNone": "No video of this project was found in the folder (size and fingerprint)",
  "toast.folderUnsupported": "This browser cannot open folders; pick the files one by one",
  "toast.folderFailed": "Cannot read the folder: {detail}",
  "toast.projectAlreadyOpen": "\"{name}\" is already in the list",
  "toast.savedTo": "Saved: {name}",
  "export.playAfter": "Play the video when the export is done",
  "player.title": "Exported: {name}",
  "drop.pickSeq": "Choose sequence folder…",
  "drop.pickSeqTip": "Choose the folder of a PNG or EXR sequence (ordered by the frame number in the file names)",
  "toast.noSequence": "No PNG or EXR sequence in the folder \"{name}\"",
  "error.open.exr": "Cannot read this EXR (multi-layer, deep, or unsupported channel names; export a single-layer RGB / RGBA EXR)",
  "seq.fps": "Frame rate",
  "seq.frames": "{pattern} ({first}–{last})",
  "seq.exrGamut": "EXR view",
  "seq.gamut.rec709": "Linear Rec.709 / sRGB",
  "seq.gamut.acescg": "ACEScg (AP1)",
  "seq.gamut.aces2065": "ACES2065-1 (AP0)",
  "seq.transfer.srgb": "sRGB curve",
  "seq.transfer.rec709": "Rec.709 curve",
  "seq.transfer.gamma24": "Gamma 2.4",
  "seq.transfer.linear": "Linear (none)",
  "seq.exposure": "Exposure (stops)",
  "seq.exrNote": "Highlights above 1.0 are clipped",
  "drop.link": "Paste link…",
  "drop.linkTip": "A moonland generation or reference video (right-click its thumbnail → Copy image address), a Google Drive video shared by link, or a YouTube video (needs the local helper); you can also press Ctrl+V anywhere in the window",
  "drop.refetching": "Downloading again from the original link…",
  "link.title": "Add videos from links",
  "link.label": "Links to moonland generations (or a reference video's thumbnail image address), Google Drive or YouTube videos; several at once fill the empty slots in order (separate them with spaces or lines). YouTube needs the local helper running. Where videos are kept is set in Settings.",
  "toast.link.driveFolder": "Google Drive folder links cannot be used; paste the link of a single video file (right-click the file → Share → Copy link).",
  "toast.link.none": "No recognised link. moonland, Google Drive and YouTube video links are supported.",
  "toast.link.downloading": "Downloading {n} video(s)… {pct}%",
  "toast.link.done": "Downloaded {n} video(s)",
  "toast.link.failed": "Could not download {id}: {reason}",
  "toast.link.shotChanged": "Downloaded {n} video(s); another shot was opened meanwhile, so they were not loaded",
  "error.remote.network": "Connection failed; check the network (an internal company network may not reach outside sites)",
  "error.remote.notFound.moonland": "moonland does not give this card's video location (cards marked 來源 with a camera icon cannot be dragged out). Use the card's ⋮ menu → 前往源頭生成, copy the address of the page that opens and press Ctrl+V in AiComp",
  "error.remote.notFound.gdrive": "The file is not available: check that anyone with the link can view it, or its download quota for today is used up",
  "error.remote.notVideo": "The downloaded content is not a video file",
  "toast.link.youtubeList": "Paste the link of a single YouTube video (playlist and channel links cannot be used).",
  "error.remote.helper": "YouTube needs the local helper: double-click the “AiComp YouTube helper” desktop shortcut (or helper/start-helper in the AiComp folder), keep its window open and paste again. Not installed yet: see the install guide in the kit. Chrome asks once whether to allow access to the local network; choose Allow",
  "error.remote.ytdlp": "The local helper cannot find yt-dlp; run helper/start-helper again to install it",
  "error.remote.youtube": "YouTube download failed",
  "toast.link.dragImage": "That is a picture; drag a video (a generation, a reference video or a video from the library)",
  "toast.link.dragNone": "The dropped item was not recognised; drag a moonland video, a video file or a video link",
  "align.target": "The version to align (also switchable here in the quad layout)",
  "align.auto": "Auto-align",
  "align.autoTip": "Compares centre, stretch, fit and an arbitrary-scale estimate on the current frame and applies the one with the smallest difference (undoable). Runs by itself when a version whose size differs from A is loaded.",
  "align.points": "Two points",
  "align.pointsTip": "Mark the same two places on A and on B (an eye corner, a sign corner…); B's scale and position are worked out from them. For videos that were scaled, cropped or re-framed so their sizes do not line up",
  "align.points.guide": "Click the same two places on A and on {b}, in the same order (1, 2): A {na}/2 · {b} {nb}/2. Clicking the top pictures moves the crosshair; refine in the zoom panes below (a click near a point moves it). Esc cancels",
  "align.points.reset": "Start over",
  "align.points.done": "Aligned by two points: scale X {sx}% Y {sy}%, shift {dx}, {dy} (undoable)",
  "align.points.bad": "The points are too close or not in the same order on A and B; mark them again (far apart, e.g. top left and bottom right)",
  "align.points.borrowed.x": "the points are almost above each other, so the width scale follows the height scale",
  "align.points.borrowed.y": "the points are almost level, so the height scale follows the width scale",
  "align.autoRunning": "Auto-aligning…",
  "align.suggestion": "Suggested:",
  "align.notAligned": "Size differs from A; press Auto-align",
  "align.infoSame": "{id} {w}×{h}, same as A",
  "align.manual": "Manual fine-tuning",
  "card.summary": "{w}×{h} · {fps} fps · {n} frames · {codec}",
  "card.offset": "Time offset",
  "card.offsetValue": "{n} frames",
  "card.advanced": "Advanced",
  "srcmenu.tip": "Actions for {id}: replace, align, remove…",
  "srcmenu.replace": "Replace video…",
  "srcmenu.replaceSeq": "Replace sequence folder…",
  "srcmenu.replaceLink": "Replace from a link…",
  "srcmenu.align": "Align…",
  "srcmenu.swapA": "Swap with A",
  "srcmenu.viewAlone": "View this one alone",
  "srcmenu.viewAll": "Back to side by side",
  "srcmenu.remove": "Remove {id}",
  "spec.warn.resolutionAligned": "Resolution differs (A {a}, this version {b}); auto-aligned",
  "settings.secLinks": "Videos from links",
  "settings.linkSave": "After download",
  "settings.linkSave.folder": "Save to a folder",
  "settings.linkSave.none": "Memory only (not saved)",
  "settings.linkFolderPick": "Choose folder…",
  "settings.linkFolderNow": "Folder: {folder}",
  "settings.linkFolderNone": "Not chosen yet",
  "toast.link.folderSet": "Videos will be saved into \"{folder}\"",
  "toast.link.noFolder": "No folder to save into; kept in memory this time (choose a folder in Settings)",
  "toast.link.saveFailed": "Could not save into \"{folder}\"; kept in memory this time",
  "card.diffs": "{n} spec differences",
  "card.check": "Check time alignment",
  "toolbar.compareBase": "vs",
  "toolbar.compareBaseTip": "What wipe / overlay / flicker / difference compare against: A (original) or another AI version",
  "side.splitTip": "Drag to resize the project list and the tool panel; double-click for automatic",
  "badge.alignHint": "{id} may be misaligned: {what}",
  "align.hintShift": "shift {dx}, {dy} px",
  "align.hintScale": "scale {sx}% × {sy}%",
  "align.hintApply": "Apply",
  "align.hintIgnore": "Ignore",
  "export.alignWarn": "{ids} may not be aligned yet, so the comparison will be offset; press Apply on the reminder in the picture",
  "toolbar.shot": "Screenshot",
  "toolbar.shotTip": "Save the current view (with labels and crosshair) as a PNG image",
  "export.labelBefore": "Original (e.g. Before)",
  "export.labelAfter": "AI version (e.g. After)",
  "export.opening": "Opening",
  "export.openingNone": "None",
  "export.openingCard": "Title card",
  "export.openingVideo": "Chosen video",
  "export.introPick": "Choose video…",
  "export.introFile": "{name} ({s} s)",
  "export.introNone": "No opening video chosen",
  "export.errIntro": "Cannot read the opening video: {name}",
  "export.options": "Options",
  "export.saveTo": "Save to",
  "export.folderPick": "Choose folder…",
  "export.folderTip": "Folder for the exported video (the project folder by default)",
  "export.sumDur": "{s} s",
  "export.sumMb": "about {mb} MB",
  "export.sumAudioOn": "audio: {a}",
  "export.sumAudioOff": "no audio",
  "export.replaceTitle": "File exists",
  "export.replaceBody": "“{name}” already exists in “{folder}”. Replace it?",
  "export.replace": "Replace",
  "tree.menuTip": "Project: new, open, save",
  "tree.saveAs": "Save as…",
  "tree.create": "Create",
  "tree.folder": "Default folder",
  "tree.folderNone": "Not chosen",
  "tree.folderPick": "Choose folder…",
  "tree.folderNote": "Downloaded videos are saved here; exports and screenshots are saved here by default",
  "tree.folderSkipped": "No default folder: downloaded videos go to the folder in the settings",
  "dock.check": "Check",
  "quality.run": "Check {id}",
  "quality.again": "Check {id} again",
  "quality.sensTip": "Sensitivity: higher lists milder problems",
  "quality.sens.low": "Sensitivity low",
  "quality.sens.medium": "Sensitivity medium",
  "quality.sens.high": "Sensitivity high",
  "quality.range": "Checks the in–out range only",
  "quality.phaseFrames": "Checking frames {p}%…",
  "quality.phasePixels": "Comparing frames {p}%…",
  "quality.error": "Check failed: {detail}",
  "quality.stale": "The version, alignment or range changed; check again",
  "quality.offsetHint": "Time may be misaligned: suggested offset {n} frames (apply it in the Media tab)",
  "quality.none": "Nothing suspicious found",
  "quality.more": "{n} more",
  "quality.visTip": "Show / hide on the timeline",
  "quality.cat.frames": "Dropped / repeated frames",
  "quality.cat.motion": "Frozen / jittery motion",
  "quality.cat.seam": "Processing seams",
  "quality.cat.flicker": "Flicker",
  "quality.cat.color": "Colour",
  "quality.cat.clip": "Clipping and tone",
  "quality.cat.banding": "Banding",
  "quality.cat.boiling": "Texture boiling",
  "quality.k.freeze": "Frozen: B moves only {p}% as much as A",
  "quality.k.jitter": "Jitter: B moves {x}× as much as A",
  "quality.k.seam.color": "Colour changes abruptly (ΔE {v})",
  "quality.k.seam.luma": "Processing changes abruptly (difference {v})",
  "quality.k.flicker.luma": "Brightness flicker ({v} levels)",
  "quality.k.flicker.chroma": "Colour flicker (ΔE {v})",
  "quality.k.skin": "Skin tone shift ΔE {v}",
  "quality.k.skinHue": "Skin hue shift {v}°",
  "quality.k.cell": "Local colour shift ΔE {v}",
  "quality.k.sat": "Saturation down {v}%",
  "quality.k.high": "Highlights clipped ({v}% more)",
  "quality.k.low": "Shadows crushed ({v}% more)",
  "quality.k.tone": "Tone changed ({v}%)",
  "quality.k.banding": "Banding in a smooth gradient",
  "quality.k.boiling": "Texture changes frame to frame",
  "quality.k.dupRun": "{n} repeated frames in a row from this version's frame {b}",
  "quality.desc.frames": "Frames missing, added or repeated in B (frame-by-frame mapped versions only)",
  "quality.desc.motion": "B stops while A moves (frozen), or B shakes more than A (jitter)",
  "quality.desc.seam": "B's colour or processing changes abruptly at one frame, typical of segmented AI processing",
  "quality.desc.flicker": "Brightness or colour jumping back and forth frame to frame, more in B than in A",
  "quality.desc.color": "Skin tone shift, local colour shift, loss of saturation",
  "quality.desc.clip": "Highlights or shadows newly clipped in B, or a changed tonal balance",
  "quality.desc.banding": "Steps appearing in smooth gradients (sky, walls)",
  "quality.desc.boiling": "Fine texture (skin, hair, grass) changing every frame so it seems to crawl",
  "settings.language": "Language",
  "settings.secGeneral": "General",
  "settings.linkFolder": "Folder",
  "color.hint.untagged": "This version has no colour tags and is treated as {b}; A is {a}, so colours may not compare correctly",
  "color.hint.differs": "Colour tags differ from A (A: {a}, this version: {b}); if they are wrong, colours will look off",
  "color.hint.apply": "Match A ({a})",
  "params.bandTip": "Which layer to compare",
  "params.band.all": "All",
  "params.band.low": "Light",
  "params.band.high": "Detail",
  "params.band.allTip": "Difference of the whole picture",
  "params.band.lowTip": "Light and colour only (blurred pictures); changes of detail are hidden (F-05.6)",
  "params.band.highTip": "Detail and structure only (light and colour removed); overall grading is hidden, good for checking facial detail (F-05.7)",
  "quality.all": "Check whole project",
  "quality.allTip": "Opens each shot in turn and checks the versions not checked yet (or changed); shots whose videos cannot be opened directly are skipped",
  "quality.batch": "Shot {i}/{n}",
  "quality.allDone": "Project check finished: {n} versions checked, {s} shots skipped",
  "tree.qcTip": "Automatic quality check result (current sensitivity)",
  "tree.qcFound": "⚠ {n}",
  "tree.qcNone": "✓ checked",
  "sheet.button": "Export problem sheets",
  "sheet.tip": "One tile per suspicious segment: A | B and the problem enlarged, six per PNG, to hand to whoever fixes it",
  "sheet.file": "problems",
  "sheet.progress": "Making problem sheets {d}/{n}…",
  "sheet.done": "{n} problem sheet(s) saved to \"{folder}\"",
  "sheet.downloads": "Downloads",
  "sheet.wholeFrame": "(whole-frame problem, no specific spot)",
  "drop.transcoding": "Converting with the local helper {p}% (ProRes and other formats the browser cannot play become H.264)…",
  "toast.transcoded": "Converted to H.264: {name}",
  "toast.transcodeFailed": "Could not convert {name}: {reason}",
  "error.transcode.helperOld": "The local helper is too old; reinstall it from the kit",
  "error.transcode.ffmpeg": "The local helper has no ffmpeg",
  "error.transcode.failed": "ffmpeg could not convert it",
  "error.transcode.noHelper": "The local helper is needed: double-click the “AiComp YouTube helper” shortcut, keep its window open and drop the file again",
  "quality.cat.face": "Face",
  "quality.desc.face": "Finds the face and compares A and B: features moved, the face missing in B, different blinks or mouth; turned-head stretches are listed as error-prone (in-browser face model, no network)",
  "quality.k.face.drift": "{part} moved ({v}% of the eye distance)",
  "quality.k.face.lost": "B has no face here (A has)",
  "quality.k.face.blink": "Blink differs from A ({v}%)",
  "quality.k.face.mouth": "Mouth opening differs from A ({v}%)",
  "quality.k.face.turned": "Turned head: the angle AI gets wrong most, look closely",
  "quality.part.eyes": "Eyes",
  "quality.part.brows": "Brows",
  "quality.part.nose": "Nose",
  "quality.part.mouth": "Mouth",
  "quality.part.jaw": "Jaw line",
  "ai.secTitle": "Analysis (cloud)",
  "ai.key": "Anthropic API key",
  "ai.keyPlaceholder": "sk-ant-… (kept in this browser only)",
  "ai.keyClear": "Clear",
  "ai.model": "Model",
  "ai.model.sonnet": "Claude Sonnet 5.5 (default, faster and cheaper)",
  "ai.model.opus": "Claude Opus 5.5 (more accurate, costlier)",
  "ai.notice": "With “Analyze”, A and B pictures of the chosen frames (long edge 1024 px) are sent to Anthropic’s servers and billed to this API key’s account. Make sure the material may leave the company.",
  "ai.briefPlaceholder": "What the AI edit was meant to do (optional), e.g. background replaced",
  "ai.briefTip": "Tells the AI which changes are intended so they are not listed; kept with the shot",
  "ai.button": "Analyze",
  "ai.paused": "Paused (under evaluation)",
  "ai.empty": "No analysis results yet",
  "dock.analysis": "Analysis",
  "ai.sendNote": "⚠ Sends A and B pictures of 8 frames to Anthropic (cloud) for analysis",
  "ai.running": "Analyzing {d}/{n}…",
  "ai.done": "Analysis finished: {n} problem(s) listed",
  "ai.failed": "Analysis failed: {reason}",
  "ai.error.noKey": "Enter an Anthropic API key in the settings first",
  "ai.error.key": "The API key is invalid or not allowed",
  "ai.error.rate": "Too many requests; try again later",
  "ai.error.network": "Cannot reach Anthropic (the company network may block api.anthropic.com)",
  "ai.error.api": "Anthropic returned an error",
  "quality.cat.ai": "Analysis",
  "quality.desc.ai": "Problems listed by Claude looking at A and B (fingers, faces, text, objects, edges…); only when you press “Analyze”, pictures are sent to the cloud",
  "quality.k.ai.none": "(no description)",
};
